import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { AuthenticationWrap } from './overview/style';

const AuthLayout = (WraperContent) => {
  const isApproverPath = ['/approver', '/commenter'].some((prefix) => window.location.pathname.startsWith(prefix));

  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <AuthenticationWrap
          className={isApproverPath ? 'approverWrapper' : ''}
          style={{ backgroundImage: `url("${require('../../../static/img/admin-bg-light.png')}")` }}
        >
          <div className="ninjadash-authentication-wrap">
            {/* <div className="ninjadash-authentication-brand">
              <img src={require(`../../../static/img/barksdale-group-portal-logo.svg`).default} alt="" style={{height:'85px'}}/>
            </div> */}
            <WraperContent />
          </div>
        </AuthenticationWrap>
      </Suspense>
    );
  };
};

export default AuthLayout;
